import cx from 'classnames';
import type {
  CSSProperties,
  FC,
  HTMLAttributeAnchorTarget,
  ReactNode,
} from 'react';
import { Link } from 'umi';
import { useFormatMessage } from '@/hooks';
import './index.less';

const prefix = 'beukay-empty';
const getCx = (className: string) => `${prefix}-${className}`;

/**
 * default,error-通用错误,search-搜索,car-购物车,order-订单,coupon-优惠券,collect-收藏,address-收货地址,notification-通知,nodata-暂无内容
 */
type Type =
  | 'default'
  | 'error'
  | 'search'
  | 'car'
  | 'order'
  | 'coupon'
  | 'collect'
  | 'address'
  | 'notification'
  | 'nodata';

type IProps = {
  visible?: boolean;
  className?: string;
  type?: Type;
  image?: string;
  size?: 'normal' | 'small';
  imageStyle?: CSSProperties;
  description?: string;
  footer?: {
    type?: 'button' | 'link';
    className?: string;
    text?: string;
    link?: string;
    linkTarget?: HTMLAttributeAnchorTarget;
    onClick?: (...args: any) => void;
  };
  children?: ReactNode;
};

const getImage = (type: Type) =>
  `https://file.meilisci.com/resource/empty-${type}.svg`;

const Empty: FC<IProps> = ({
  visible = true,
  className,
  type = 'default',
  image,
  size = 'normal',
  imageStyle,
  description,
  footer,
  children,
}) => {
  const { formatMessage } = useFormatMessage();
  const img = image || getImage(type);
  const desc =
    description !== undefined
      ? description
      : formatMessage({ id: `components.empty.desc.${type}` });
  const getFooter = () => {
    if (!footer) return null;
    const footerText = footer.text ?? '去逛逛';
    const target = footer.linkTarget ?? '_blank';

    if (footer.type === 'link')
      return (
        <Link
          to={footer.link || '/'}
          className={cx(getCx('footer'), footer.className)}
          onClick={footer.onClick}
          target={target}
        >
          {footerText}
        </Link>
      );
    return (
      <div
        className={cx(getCx('footer'), footer.className)}
        onClick={footer.onClick}
      >
        {footerText}
      </div>
    );
  };

  return visible ? (
    <div className={cx(prefix, className)}>
      <div className={getCx('image-wrapper')}>
        <img
          src={img}
          className={cx(getCx('image'), {
            [getCx('image-small')]: size === 'small',
          })}
          style={imageStyle}
          alt={desc}
        />
      </div>
      {desc && <div className={getCx('desc')}>{desc}</div>}
      {getFooter()}
      {children}
    </div>
  ) : null;
};

export default Empty;
